import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LayoutShellComponent } from './layout/layout-shell/layout-shell.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'homepage', pathMatch: 'full' },
      {
        path: 'homepage',
        loadChildren: () => import('./modules/homepage/homepage.module').then((m) => m.HomepageModule),
        data: { breadcrumb: 'Home' },
      },
      {
        path: 'customers',
        loadChildren: () => import('./modules/customer-data/customers/customers.module').then((m) => m.CustomersModule),
        data: { breadcrumb: 'Customers' },
      },
      {
        path: 'clubs',
        loadChildren: () => import('./modules/customer-data/clubs/clubs.module').then((m) => m.ClubsModule),
        data: { breadcrumb: 'Clubs' },
      },
      {
        path: 'invoices',
        loadChildren: () => import('./modules/customer-data/invoices/invoices.module').then((m) => m.InvoicesModule),
        data: { breadcrumb: 'Invoices' },
      },
      {
        path: 'transactions',
        loadChildren: () =>
          import('./modules/customer-data/transactions/transactions.module').then((m) => m.TransactionsModule),
        data: { breadcrumb: 'Transactions' },
      },
      {
        path: 'tickets',
        loadChildren: () => import('./modules/customer-data/tickets/tickets.module').then((m) => m.TicketsModule),
        data: { breadcrumb: 'Tickets' },
      },
      {
        path: 'insights',
        loadChildren: () =>
          import('./modules/customer-insights/insights/insights/insights.module').then((m) => m.InsightsModule),
        data: { breadcrumb: 'Insights' },
      },
      {
        path: 'insights-plus',
        loadChildren: () =>
          import('./modules/customer-insights/insights-plus/insights-plus/insights-plus.module').then(
            (m) => m.InsightsPlusModule,
          ),
        data: { breadcrumb: 'Insights Plus' },
      },
      {
        path: 'schemas',
        loadChildren: () => import('./modules/loyalty-model/schemas/schemas.module').then((m) => m.SchemasModule),
        data: { breadcrumb: 'Schemas' },
      },
      {
        path: 'redeem-rules',
        loadChildren: () =>
          import('./modules/loyalty-model/redeem-rules/redeem-rules.module').then((m) => m.RedeemRulesModule),
        data: { breadcrumb: 'Redeem Rules' },
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./modules/campaign-management/campaigns/campaigns.module').then((m) => m.CampaignsModule),
        data: { breadcrumb: 'Campaigns' },
      },
      {
        path: 'campaign-executions',
        loadChildren: () =>
          import('./modules/campaign-management/campaign-executions/campaign-executions.module').then(
            (m) => m.CampaignExecutionsModule,
          ),
        data: { breadcrumb: 'Campaign Executions' },
      },
      {
        path: 'coupons',
        loadChildren: () =>
          import('./modules/campaign-management/coupons/coupons-routing.module').then((m) => m.CouponsRoutingModule),
        data: { breadcrumb: 'Coupons' },
      },
      {
        path: 'checkbooks',
        loadChildren: () =>
          import('./modules/campaign-management/checkbooks/checkbooks.module').then((m) => m.CheckbooksModule),
        data: { breadcrumb: 'Checkbooks' },
      },
      {
        path: 'bulk-operations',
        loadChildren: () =>
          import('./modules/customer-operations/bulk-operations/bulk-operations.module').then(
            (m) => m.BulkOperationsModule,
          ),
        data: { breadcrumb: 'Bulk Operations' },
      },
      {
        path: 'flows',
        loadChildren: () => import('./modules/automation-center/flows/flows.module').then((m) => m.FlowsModule),
        data: { breadcrumb: 'Flows' },
      },
      {
        path: 'recipes',
        loadChildren: () => import('./modules/automation-center/recipes/recipes.module').then((m) => m.RecipesModule),
        data: { breadcrumb: 'Recipes' },
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('./modules/administration/user-management/user-management.module').then((m) => m.UserManagementModule),
        data: { breadcrumb: 'User Management' },
      },
      {
        path: 'platform-management',
        loadChildren: () =>
          import('./modules/administration/platform-management/platform-management.module').then(
            (m) => m.PlatformManagementModule,
          ),
        data: { breadcrumb: 'Platform Management' },
      },
      {
        path: 'locale-management',
        loadChildren: () =>
          import('./modules/administration/locale-management/locale-management.module').then(
            (m) => m.LocaleManagementModule,
          ),
        data: { breadcrumb: 'Locale Management' },
      },
      {
        path: 'integration-management',
        loadChildren: () =>
          import('./modules/administration/integration-management/integration-management.module').then(
            (m) => m.IntegrationManagementModule,
          ),
        data: { breadcrumb: 'Integrations' },
      },
      {
        path: 'store-management',
        loadChildren: () =>
          import('./modules/data-customization/store-management/store-management.module').then(
            (m) => m.StoreManagementModule,
          ),
        data: { breadcrumb: 'Store Management' },
      },
      {
        path: 'tag-management',
        loadChildren: () =>
          import('./modules/data-customization/tag-management/tag-management.module').then(
            (m) => m.TagManagementModule,
          ),
        data: { breadcrumb: 'Tag Management' },
      },
      {
        path: 'brand-management',
        loadChildren: () =>
          import('./modules/data-customization/brand-management/brand-management.module').then(
            (m) => m.BrandManagementModule,
          ),
        data: { breadcrumb: 'Brand Management' },
      },
      {
        path: 'merchant',
        loadChildren: () => import('./modules/merchant/merchant.module').then((m) => m.MerchantModule),
        data: { breadcrumb: 'Merchant' },
      },
      { path: '**', loadChildren: () => import('./modules/not-found/not-found.module').then((m) => m.NotFoundModule) },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
